import { apiClient } from '@/shared/api';
import {
  EmployeeGroupDetailResponse,
  EmployeeGroupEmployeesRequest,
  EmployeeGroupListResponse,
  EmployeeGroupRequest,
  EmployeeGroupResponse,
} from './types';

/**
 * Получить список групп операторов: GET /employeeGroup.
 */
export const fetchEmployeeGroups = async (params?: {
  name?: string;
  limit?: number;
  offset?: number;
}): Promise<EmployeeGroupListResponse> => {
  const { data } = await apiClient.get<EmployeeGroupListResponse>('/employeeGroup', { params });
  return data;
};

/**
 * Получить группу операторов по идентификатору: GET /employeeGroup/{id}.
 */
export const fetchEmployeeGroupById = async (id: number): Promise<EmployeeGroupDetailResponse> => {
  const { data } = await apiClient.get<EmployeeGroupDetailResponse>(`/employeeGroup/${id}`);
  return data;
};

/**
 * Создать группу операторов: POST /employeeGroup.
 */
export const createEmployeeGroup = async (body: EmployeeGroupRequest): Promise<EmployeeGroupResponse> => {
  const { data } = await apiClient.post<EmployeeGroupResponse>('/employeeGroup', body);
  return data;
};

/**
 * Обновить группу операторов: PUT /employeeGroup/{id}.
 */
export const updateEmployeeGroup = async ({
  id,
  body,
}: {
  id: number;
  body: EmployeeGroupRequest;
}): Promise<EmployeeGroupResponse> => {
  const { data } = await apiClient.put<EmployeeGroupResponse>(`/employeeGroup/${id}`, body);
  return data;
};

/**
 * Удалить группу операторов: DELETE /employeeGroup/{id}.
 */
export const deleteEmployeeGroup = async (id: number): Promise<void> => {
  await apiClient.delete(`/employeeGroup/${id}`);
};

/**
 * Добавить операторов в группу: POST /employeeGroup/{id}/employees.
 */
export const addEmployeesToGroup = async ({
  id,
  body,
}: {
  id: number;
  body: EmployeeGroupEmployeesRequest;
}): Promise<void> => {
  await apiClient.post(`/employeeGroup/${id}/employees`, body);
};

/**
 * Исключить операторов из группы: DELETE /employeeGroup/{id}/employees.
 */
export const removeEmployeesFromGroup = async ({
  id,
  body,
}: {
  id: number;
  body: EmployeeGroupEmployeesRequest;
}): Promise<void> => {
  await apiClient.delete(`/employeeGroup/${id}/employees`, { data: body });
};
